import {isProxy, toRaw} from 'vue';

// noinspection JSUnusedGlobalSymbols
export default {
    name: "Calculator",
    props: {
        metricId: {
            type: Number,
            default: 0,
        },
        images: {
            type: Object,
            default: {},
            required: true,
        },
        types: {
            type: Object,
            default: {},
            required: true,
        },
        mounting: {
            type: Object,
            default: {},
            required: true,
        },
        hardware: {
            type: Object,
            default: {},
            required: true,
        },
        glass: {
            type: Object,
            default: {},
            required: true,
        },
        decoration: {
            type: Object,
            default: {},
            required: true,
        },
        constructs: {
            type: Object,
            default: {},
            required: true,
        },
        loadedCart: {
            type: Object,
            default: {},
            required: true,
        },
        templateFolder: {
            type: String,
            default: '',
            required: true,
        },
        userKey: {
            type: String,
            default: '',
            required: true,
        },
        availableQuantity: {
            type: Number,
            default: 999,
            required: false,
        },
        hashPage: {
            type: Boolean,
            default: false,
            required: false,
        },
        coefficients: {
            '1': 1,
            '1.15': 1.15,
            '1.3': 1.3,
            '1.4': 1.4,
            '1.5': 1.5,
            '1.6': 1.6,
        },
        mounting_prices: {
            'Mper1': 1600,
            'Mper2': 1500,
            'Mper3': 1400,
            'Mzer1': 2000,
            'Mzer2': 1400,
            'Mzer3': 1300,
            'Mzer4': 1200,
        },
        color: {
            type: String,
            default: '#364AF6',
            required: true,
        },
        colorHover: {
            type: String,
            default: '#6776f8',
            required: true,
        }
    },
    data() {
        return {
            selectedTypes: [],

            selectedConstruct: {},

            selectedGlassArticle: '',
            constructGlasses: [],

            selectedDecorationArticle: '',
            constructDecoration: {},

            selectedSizesIndex: 0,

            height: 2000,
            sideSize1: 600,
            sideSize2: 600,

            furnitureType: 'default',

            lockEnabled: false,
            mountingEnabled: false,
            deliveryEnabled: false,

            lockPrice: 2000,
            deliveryPrice: 3800,

            KDoor: 1,
            quantity: 1,

            isEditingMode: false,
            currentCartProductId: 0,

            cart: Object.assign({}, this.loadedCart),

            currentStep: 1,

            name: '',
            email: '',
            phone: '',

            isHashPage: this.hashPage,
            priceData: {
                'basePrice': 0,
                'deliveryPrice': 0,
                'mountingPrice': 0,
                'lockPrice': 0,
            },

            debugCounter: 0,
        }
    },
    mounted() {
        this.setColor(this.color, this.colorHover);

        this.emitter.on('calculator-go-to-step', step => {
            this.currentStep = step;
        });

        this.emitter.on('calculate-product-price', params => {
            if (!params['CONSTRUCT_ID']) {
                return 0;
            }

            let savedParametersKeys = [
                'currentStep', 'selectedTypes', 'selectedConstruct', 'constructGlasses', 'selectedGlassArticle',
                'constructDecoration', 'selectedDecorationArticle', 'furnitureType', 'selectedSizesIndex', 'lockEnabled',
                'mountingEnabled', 'deliveryEnabled', 'height', 'sideSize1', 'sideSize2', 'quantity',
            ];
            let savedParameters = {};

            savedParametersKeys.forEach(parameterKey => {
                let parameter;
                if (isProxy(this[parameterKey])) {
                    parameter = toRaw(this[parameterKey]);
                } else {
                    parameter = this[parameterKey];
                }
                savedParameters[parameterKey] = parameter;
            });

            this.currentStep = 3;

            this.selectedTypes = Object.values(params['TYPES']).map(typeId => this.findTypeById(typeId)).filter(type => type);
            this.selectedConstruct = this.selectedType['CONSTRUCTS'][params['CONSTRUCT_ID']];
            this.constructGlasses = this.selectedConstruct['GLASS'];
            this.selectedGlassArticle = params['GLASS_ARTICLE'];

            this.constructDecoration = this.selectedConstruct['DECORATION'];
            this.selectedDecorationArticle = params['DECORATION_ARTICLE'];

            this.furnitureType = params['FURNITURE_TYPE'];

            this.selectedSizesIndex = 'custom';

            this.lockEnabled = params['USE_LOCK'];
            this.mountingEnabled = params['USE_MOUNTING'];
            this.deliveryEnabled = params['USE_DELIVERY'];

            this.height = params['SIZES'][0];
            this.sideSize1 = params['SIZES'][1];
            this.sideSize2 = Number(params['SIZES'][2]);

            this.quantity = 1;
            this.emitter.emit('calculate-product-price-result', {
                price: this.price,
                priceData: toRaw(this.priceData),
                formattedPrice: this.formattedPrice,

                itemNode: params['ITEM_NODE'],
            });

            savedParametersKeys.forEach(parameterKey => {
                this[parameterKey] = savedParameters[parameterKey];
            });
            savedParameters = {};
        });

        const fixedProps = [
            'height',
            'sideSize1',
            'sideSize2',
        ];
        this.baywatch(fixedProps, () => {
            fixedProps.forEach(key => {
                if((this.isPartitions || this.isMirrors)) {
                    if (typeof this[key] === 'string') {
                        this[key] = this[key].replace(',', '.');
                        if (this[key].slice(-1) === '.') {
                            return;
                        }
                    }
                }
                this[key] = this.fixNumber(this[key]).toLocaleString('ru-RU', {'maximumFractionDigits': 1}).replace(',', '.');
            });
        });
    },
    watch: {
        quantity(newValue, oldValue) {
            if (typeof newValue !== "number" || isNaN(newValue)) {
                newValue = this.quantity = oldValue;
            }

            if (newValue < 1) {
                newValue = this.quantity = 1;
            }

            if (newValue > this.availableQuantity && this.availableQuantity > 0) {
                newValue = this.quantity = this.availableQuantity;
            }
        },
        KDoor(newValue, oldValue) {
            if (typeof newValue !== "number" || isNaN(newValue)) {
                newValue = this.KDoor = oldValue;
            }

            if (newValue < 1) {
                newValue = this.KDoor = 1;
            }

            if (newValue > 99999) {
                newValue = this.KDoor = 99999;
            }
        },
        currentStep(step) {
            if (step === 2) {
                this.sendMetric('gotostep2');
            }
            if (step === 3) {
                setTimeout(function () {
                    if (typeof $().theiaStickySidebar === 'function') {
                        $('.calculator-product-img').theiaStickySidebar({
                            additionalMarginTop: 32,
                            additionalMarginBottom: 32,
                            scrollSelector: '.modal-calculator .modal-wrapp',
                        });
                    }
                }, 100);
                this.sendMetric('gotostep3');
            }
            if (step === 4) {
                this.sendMetric('gotocart');
            }
            if (step === 5) {
                this.$nextTick(() => {
                    let phoneInput = this.$el.querySelector('[name="phone"]');
                    let mask = IMask(phoneInput, {
                        mask: '+{7}(000)000-00-00',
                        prepare: function (str, mask) {
                            if ((mask.unmaskedValue === '' || mask.unmaskedValue === '7') && (str === '8' || str === '7')) {
                                return false;
                            }
                            return str;
                        }
                    });
                });
                this.sendMetric('gotocheckout');
            }

        },
        debugCounter(counter) {
            if (counter >= 3) {
                console.log({
                    Calculator: {
                        instance: toRaw(this),

                        priceData: toRaw(this.priceData),

                        H: this.H,
                        A: this.A,
                        B: this.B,
                        Ps: this.Ps,
                        Dek: this.Dek,
                        Pf: this.Pf,
                        k1: this.k1,
                        k2: this.k2,
                        K: this.K,
                        M: this.M,
                        D: this.D,
                    }
                });

                counter = this.debugCounter = 0;
            }
        },
	    cart: {
		    handler(newCart) {
			    const cartNumElement = document.querySelector('#cart-num');
			    if (cartNumElement) {
				    // Обновляем текст элемента, например, количество товаров
				    cartNumElement.textContent = Object.keys(newCart).length;
			    }
			    console.log('qweqw')
		    },
		    deep: true,
		    immediate: true
	    }
    },
    computed: {
        isBackButtonActive() {
            if (this.currentStep === 5) {
                return true;
            }
            if (this.currentStep === 4) {
                return false;
            }

            return this.selectedTypes.length !== 0;
        },
        selectedType() {
            return this.selectedTypes[this.selectedTypes.length - 1] || {};
        },
        selectedTypeId() {
            return this.selectedType['ID'] || 0;
        },
        mainSelectedType() {
            return this.selectedTypes[0] || {};
        },
        selectedTypesIdentifiers() {
            return this.selectedTypes.map(type => Number(type['ID']));
        },
        currentTypes() {
            if (!_.isEmpty(this.selectedType['SUB_TYPES'])) {

                const typesProducts = {};
                const productsSort = Object.values(this.selectedType['SUB_TYPES']).sort(function (a, b) {
                    return a.SORT - b.SORT;
                });
                productsSort.forEach((_, ind) => {
                    typesProducts[ind] = productsSort[ind];
                });

                return typesProducts;
            }

            const typesProducts = {};
            const productsSort = Object.values(this.types).sort(function (a, b) {
                return a.SORT - b.SORT;
            });
            productsSort.forEach((_, ind) => {
                typesProducts[ind] = productsSort[ind];
            });

            return typesProducts;
        },
        selectedConstructId() {
            return this.selectedConstruct['ID'] || 0;
        },
        currentConstructs() {
            if (!_.isEmpty(this.selectedType['CONSTRUCTS'])) {
                return Object.values(this.selectedType['CONSTRUCTS']).sort(function(a, b) {
                    return b.SORT - a.SORT;
                });
            }
            return [];
        },
        selectedGlass() {
            return this.constructGlasses[this.selectedGlassArticle] || {};
        },
        selectedDecoration() {
            return this.constructDecoration[this.selectedDecorationArticle] || {};
        },

        isShowers() {
            return this.mainSelectedType['CODE'] === 'showers';
        },
        isPartitions() {
            return this.mainSelectedType['CODE'] === 'partitions';
        },
        isPartitionsWithoutDoor() {
            return this.selectedType && this.selectedType['CODE'] === 'bez-dverey';
        },
        isDoors() {
            return this.mainSelectedType['CODE'] === 'doors';
        },
        isMirrors() {
            return this.mainSelectedType['CODE'] === 'mirrors';
        },
        isFences() {
            return this.mainSelectedType['CODE'] === 'fences';
        },
        price() {
            if (this.mainSelectedType) {
                switch (this.mainSelectedType['CODE']) {
                    case 'showers':
                        return this.showersPrice;
                    case 'partitions':
                        return this.partitionsPrice;
                    case 'doors':
                        return this.doorsPrice;
                    case 'mirrors':
                        return this.mirrorsPrice;
                    case 'fences':
                        return this.fencesPrice;
                }
            }

            return 0;
        },
        formattedPrice() {
            return this.formatNumber(this.price);
        },
        lockPriceFormatted() {
            return this.formatNumber(this.lockPrice);
        },
        deliveryPriceFormatted() {
            return this.formatNumber(this.deliveryPrice);
        },
        summaryPrice() {
            switch (this.mainSelectedType['CODE']) {
                case 'showers':
                    return this.showersSummaryPrice;
                case 'partitions':
                    return this.partitionsSummaryPrice;
                case 'doors':
                    return this.doorsSummaryPrice;
                case 'mirrors':
                    return this.mirrorsSummaryPrice;
                case 'fences':
                    return this.fencesSummaryPrice;
            }

            return 0;
        },
        formattedSummaryPrice() {
            return this.formatNumber(this.summaryPrice);
        },
        showersPrice() { // Душевые
            let kabinaMultiplier = this.selectedType['CODE'] === 'kabina' ? 2 : 1;
            let basePrice = ((this.H * this.A * kabinaMultiplier + this.H * this.B) / 1000000 * (this.Ps + this.Dek) + this.Pf) * this.k1 * this.k2;
            this.priceData = {
                'basePrice': Math.ceil(basePrice),
                'deliveryPrice': this.D,
                'mountingPrice': this.M,
                'lockPrice': 0,
            };
            return Math.ceil(
                basePrice + this.M * 1 + this.D
            );
        },
        showersSummaryPrice() {
            let kabinaMultiplier = this.selectedType['CODE'] === 'kabina' ? 2 : 1;
            return Math.ceil(
                ((this.H * this.A * kabinaMultiplier + this.H * this.B) / 1000000 * (this.Ps + this.Dek) + this.Pf) * this.k1 * this.k2 * this.K + this.M * this.K + this.D
            );
        },
        partitionsPrice() { // Перегородки
            return this.partitionsSummaryPrice;
        },
        partitionsSummaryPrice() {
            let [Mper, Mdv] = this.partitionsMounting;
            let Zazhimnoi;

            let [Pf, KDoor, Z] = [
                this.Pf,
                this.KDoor,
                this.Z,
            ];

            Zazhimnoi = Number(this.hardware['Zazhimnoi'] ? this.hardware['Zazhimnoi']['PRICE'] : 0);

            if (this.isPartitionsWithoutDoor) {
                Pf = 0;
                KDoor = 0;
                Z = 0;
                Mdv = 0;
            }

            let basePrice = (this.H * this.A * (this.Ps + this.Dek) + Zazhimnoi * this.A * 2 + Pf * KDoor + Z * KDoor) * this.k1;
            let mountingPrice = (this.H * this.A - 1.8 * KDoor) * Mper * this.k1 + Mdv * KDoor * this.k1;
            this.priceData = {
                'basePrice': Math.ceil(basePrice),
                'deliveryPrice': this.D,
                'mountingPrice': Math.ceil(mountingPrice),
                'lockPrice': 0,
            };
            return Math.ceil(
                basePrice + mountingPrice + this.D
            );
        },
        partitionsS() {
            return Number(this.H * this.A + this.H * this.B);
        },
        partitionsMounting() {
            let Mper, Mdv;

            if (this.mountingEnabled) {
                [Mper, Mdv] = [
                    this.selectedConstruct['MOUNTING'].filter(mounting => mounting['ARTICLE'].includes('Mper'))[0],
                    this.selectedConstruct['MOUNTING'].filter(mounting => mounting['ARTICLE'].includes('Mdv'))[0],
                ];

                [Mper, Mdv] = [
                    Mper || [],
                    Mdv || [],
                ];

                [Mper, Mdv] = [Mper['PRICE'] || 0, Mdv['PRICE'] || 0];

                if (this.partitionsS < 10) {
                    Mper = this.mounting_prices['Mper1'];
                }

                if (this.partitionsS >= 10 && this.partitionsS < 30) {
                    Mper = this.mounting_prices['Mper2'];
                }

                if (this.partitionsS >= 30) {
                    Mper = this.mounting_prices['Mper3'];
                }
            } else {
                [Mper, Mdv] = [0, 0];
            }

            return [Mper, Mdv];
        },
        doorsPrice() { // Двери
            let basePrice = (this.H * this.A / 1000000 * (this.Ps + this.Dek) + this.Pf) * this.k1 * this.k2;
            let lockPrice = this.Z * this.k1 * this.k2;
            this.priceData = {
                'basePrice': Math.ceil(basePrice),
                'deliveryPrice': this.D,
                'mountingPrice': this.M,
                'lockPrice': lockPrice,
            };
            return Math.ceil(
                basePrice + lockPrice + this.M + this.D
            );
        },
        doorsSummaryPrice() {
            return Math.ceil(
                (this.H * this.A / 1000000 * (this.Ps + this.Dek) + this.Pf + this.Z) * this.k1 * this.k2 * this.K + this.M * this.K + this.D
            );
        },
        mirrorsPrice() { // Зеркала
            return this.mirrorsSummaryPrice;
        },
        mirrorsSummaryPrice() {
            let Mzer = this.mirrorsMounting;
            let basePrice = this.H * this.A * (this.Ps + this.Dek) * this.k1 * this.k2;
            let mountingPrice = Mzer * this.H * this.A * this.k1 * this.k2;
            this.priceData = {
                'basePrice': basePrice,
                'deliveryPrice': this.D,
                'mountingPrice': mountingPrice,
                'lockPrice': 0,
            };
            return Number(
                basePrice + mountingPrice + this.D
            );
        },
        mirrorsS() {
            return Number(this.H * this.A + this.H * this.B);
        },
        mirrorsMounting() {
            let Mzer;

            if (this.mountingEnabled) {
                Mzer = this.selectedConstruct['MOUNTING'].filter(mounting => mounting['ARTICLE'].includes('Mzer'))[0];

                Mzer = Mzer || [];

                Mzer = Mzer['PRICE'] || 0;

                if (this.mirrorsS < 5) {
                    Mzer = this.mounting_prices['Mzer1'];
                }

                if (this.mirrorsS >= 5 && this.mirrorsS < 10) {
                    Mzer = this.mounting_prices['Mzer2'];
                }

                if (this.mirrorsS >= 10 && this.mirrorsS < 20) {
                    Mzer = this.mounting_prices['Mzer3'];
                }

                if (this.mirrorsS >= 20) {
                    Mzer = this.mounting_prices['Mzer4'];
                }
            } else {
                Mzer = 0;
            }

            return Mzer;
        },
        fencesPrice() { // Ограждения
            let [Mog, Mpor] = this.fencesMounting;

            let APf = 0;
            let H2 = 1000;

            if (this.selectedType['CODE'] === 'na-tochkakh' && this.H > 1000) {
                H2 = this.H;
            }

            if (this.selectedType['CODE'] === 'na-stoykakh') {
                APf = this.Pf * this.k1;
            }

            let basePrice = (this.H * this.A / 1000000 * (this.Ps + this.Dek) + this.Pf) * this.k1 + APf;
            let mountingPrice = H2 * this.A / 1000000 * Mog * this.k1 + Mpor * this.k1;
            this.priceData = {
                'basePrice': Math.ceil(basePrice),
                'deliveryPrice': this.D,
                'mountingPrice': Math.ceil(mountingPrice),
                'lockPrice': 0,
            };

            return Math.ceil(
                basePrice + mountingPrice + this.D
            );
        },
        fencesSummaryPrice() {
            let [Mog, Mpor] = this.fencesMounting;

            let APf = 0;
            let H2 = 1000;

            if (this.selectedType['CODE'] === 'na-tochkakh' && this.H > 1000) {
                H2 = this.H;
            }

            if (this.selectedType['CODE'] === 'na-stoykakh') {
                APf = this.hardware['Stoiki']['PRICE'] * this.k1;
            }

            return Math.ceil(
                (this.H * this.A / 1000000 * (this.Ps + this.Dek) + this.Pf) * this.k1 * this.K + APf + H2 * this.A / 1000000 * this.K * Mog * this.k1 + this.K * Mpor * this.k1 + this.D
            );
        },
        fencesMounting() {
            let Mog, Mpor;

            if (this.mountingEnabled) {
                [Mog, Mpor] = [
                    this.selectedConstruct['MOUNTING'].filter(mounting => mounting['ARTICLE'].includes('Mog'))[0],
                    this.selectedConstruct['MOUNTING'].filter(mounting => mounting['ARTICLE'].includes('Mpor'))[0],
                ];

                [Mog, Mpor] = [
                    Mog || [],
                    Mpor || [],
                ];

                [Mog, Mpor] = [Mog['PRICE'] || 0, Mpor['PRICE'] || 0];
            } else {
                [Mog, Mpor] = [0, 0];
            }

            return [Mog, Mpor];
        },
        quantityTitle() {
            return this.quantity;
        },
        measure() {
            if (this.isPartitions || this.isMirrors) {
                return 'м.';
            }

            return 'мм.';
        },
        standardSizes() {
            let sizesList = [];

            if (Array.isArray(this.selectedConstruct['SIZES']) && !_.isEmpty(this.selectedConstruct['SIZES'])) {
                sizesList = this.selectedConstruct['SIZES'];
            } else {
                sizesList = this.selectedConstruct['THIRD_SIZE'] ? [[
                    this.height,
                    this.sideSize1,
                    this.sideSize2
                ]] : [[this.height, this.sideSize1]];
            }

            let measure = this.measure;

            return sizesList.map((sizes, index) => {
                let [H, A, B] = [sizes[0], sizes[1], sizes[2]];
                return {
                    active: index === this.selectedSizesIndex,
                    title: this.selectedConstruct['THIRD_SIZE'] ? `${H} x ${A} x ${B} ${measure}` : `${H} x ${A} ${measure}`,
                    short: this.selectedConstruct['THIRD_SIZE'] ? `${H}x${A}x${B}` : `${H}x${A}`,
                    sizes: [H, A, B],
                };
            });
        },
        selectedSizes() {
            if (this.selectedConstructId === 0) {
                return [];
            }
            return this.selectedConstruct['SIZES'][this.selectedSizesIndex] || [];
        },

        H() { // Height
            if (this.selectedConstructId === 0) {
                return 0;
            }

            if (this.selectedSizesIndex !== 'custom' && this.selectedSizes[0]) {
                return this.selectedSizes[0] || 0;
            }

            return this.fixNumber(this.height || 0);
        },
        A() { // Side size 1
            if (this.selectedConstructId === 0) {
                return 0;
            }

            if (this.selectedSizesIndex !== 'custom' && this.selectedSizes[1]) {
                return this.selectedSizes[1] || 0;
            }

            if (this.isFences) {
                return 1000;
            }

            return this.fixNumber(this.sideSize1 || 0);
        },
        B() { // Side size 2
            if (this.selectedConstructId === 0) {
                return 0;
            }
            if (!this.selectedConstruct['THIRD_SIZE_VALUE']) {
                return 0;
            }

            if (this.selectedSizesIndex !== 'custom' && this.selectedSizes[2]) {
                return this.selectedSizes[2];
            }

            return this.fixNumber(this.sideSize2);
        },
        Ps() { // Glass price
            return Number(this.selectedGlass['PRICE'] || 0);
        },
        Dek() { // Decoration price
            return Number(this.selectedDecoration['PRICE'] || 0);
        },
        basePf() { // Summary of hardware prices
            if (this.selectedConstructId === 0) {
                return 0;
            }

            return Number(this.selectedConstruct['HARDWARE_SET']
                .map(item => item['PRICE'] * item['QUANTITY'])
                .reduce((summary, price) => summary + price, 0));
        },
        Pf() { // Summary of hardware prices
            if (this.furnitureType === 'premium') {
                return Number(this.basePf * 2);
            }

            return this.basePf;
        },
        Z() { // Lock
            if (this.lockEnabled) {
                if (this.isDoors) {
                    return 2000;
                }
                if (this.isPartitions) {
                    return 1400;
                }
            }

            return 0;
        },
        M() { // Mounting
            if (this.mountingEnabled) {
                return this.selectedConstruct['MOUNTING'].reduce((summary, mounting) => summary + (mounting['PRICE'] || 0), 0);
            }

            return 0;
        },
        D() { // Delivery
            return this.deliveryEnabled ? 3800 : 0;
        },
        K() { // Quantity
            return this.quantity;
        },
        k1() { // Default size coefficient
            if (this.isFences) {
                if (this.K < 5) {
                    return this.coefficients['1.6'];
                }

                if (this.K > 5 && this.K < 15) {
                    return this.coefficients['1.5'];
                }

                if (this.K > 15) {
                    return this.coefficients['1.4'];
                }
            }

            if (this.isPartitions) {
                if (this.partitionsS < 5) {
                    return this.coefficients['1.5'];
                }

                if (this.partitionsS > 5 && this.partitionsS < 15) {
                    return this.coefficients['1.4'];
                }

                if (this.partitionsS > 15) {
                    return this.coefficients['1.3'];
                }
            }

            if (this.isMirrors) {
                if (this.mirrorsS < 5) {
                    return this.coefficients['1.6'];
                }

                if (this.mirrorsS > 5 && this.mirrorsS < 15) {
                    return this.coefficients['1.5'];
                }

                if (this.mirrorsS > 15) {
                    return this.coefficients['1.4'];
                }
            }

            return this.coefficients['1.4'];
        },
        k2() { // Custom size coefficient
            if (!this.isDoors && !this.isShowers) {
                return this.coefficients['1'];
            }

            const currentSize = this.selectedConstruct['THIRD_SIZE'] ? `${this.H}x${this.A}x${this.B}` : `${this.H}x${this.A}`;
            const standardSizes = Object.values(this.standardSizes).map(sizes => sizes['short']);

            return this.selectedSizesIndex === 'custom' && !standardSizes.includes(currentSize)
                ? this.coefficients['1.15']
                : this.coefficients['1'];
        },

        selectedConstructImageKey() {
            if (this.selectedConstructId === 0) {
                return '';
            }

            return `${this.selectedConstruct['ID']}${this.selectedDecoration['ID']}${this.selectedGlass['ID']}`;
        },
        selectedConstructImage() {
            if (this.images[this.selectedConstructImageKey]) {
                return this.images[this.selectedConstructImageKey] || null;
            }

            return this.selectedConstruct['PICTURE'] || null;
        },

        pfFormatted() {
            return this.formatNumber(this.basePf);
        },

        pfPremiumFormatted() {
            return this.formatNumber(this.basePf * 2);
        },

        mountingPriceFormatted() {
            if (this.selectedConstruct['MOUNTING']) {
                return this.formatNumber(
                    this.selectedConstruct['MOUNTING'].reduce((summary, mounting) => summary + (mounting['PRICE'] || 0), 0)
                );
            } else {
                return '0';
            }
        },

        productParameters() {
            return {
                TYPES: this.selectedTypesIdentifiers,
                CONSTRUCT: this.selectedConstructId,
                GLASS: this.selectedGlassArticle,
                DECORATION: this.selectedDecorationArticle,
                IMAGE_KEY: this.selectedConstructImageKey,
                SIZES: {
                    HEIGHT: this.H,
                    SIZE_1: this.A,
                    SIZE_2: this.B,
                },
                FURNITURE_TYPE: this.furnitureType,
                ADDITIONAL: {
                    USE_LOCK: this.lockEnabled,
                    USE_MOUNTING: this.mountingEnabled,
                    USE_DELIVERY: this.deliveryEnabled,
                },
                QUANTITY: this.quantity,
                PRICE: this.price,
                SUMMARY_PRICE: this.summaryPrice
            }
        },

        isEmptyCart() {
            return _.isEmpty(this.cart);
        },
        cartLength() {
            return Object.keys(this.cart).length;
        },
        firstThreeCartElements() {
            return Object.values(this.cart).slice(0, 3);
        },
        cartSummary() {
            return Object.values(this.cart).reduce((summary, cartItem) => summary + cartItem['SUMMARY_PRICE'], 0);
        },
        cartSummaryFormatted() {
            return this.formatNumber(this.cartSummary);
        },
        sizesSectionTitle() {
            if (this.isFences) {
                return 'Высота ограждения';
            }

            if (this.isPartitions) {
                return 'Размеры перегородки';
            }

            return 'Размеры';
        }
    },
    methods: {
        setColor: function (color, colorHover) {
            const nodes = document.querySelectorAll('.calculator-scoped');
            nodes.forEach(function (node) {
                node.style.setProperty('--calculator-color', color);
                node.style.setProperty('--calculator-color-hover', colorHover || color);
            });
        },
        baywatch: function (props, watcher) {
            const iterator = function (prop) {
                this.$watch(prop, watcher);
            };
            props.forEach(iterator, this);
        },
        fixNumber: value => {
            let result = Number(
                String(value)
                    .replaceAll(' ', '')
                    .replaceAll(' ', '')
            );

            return isNaN(result) ? 0 : result;
        },
        bulletStep(step) {
            if (step === 2) {
                if (this.currentStep === 3) {
                    this.backButton();
                }
            }

            if (step === 1) {
                if (this.currentStep === 3) {
                    this.backButton();
                    this.backButton();
                } else if (this.currentStep === 2) {
                    this.backButton();
                }
            }
        },
        backButton() {
            if (this.currentStep === 1) {
                this.selectedTypes.length -= 1;
            }
            if (this.currentStep === 2) {
                this.selectedTypes.length -= 1;
                this.currentStep--;
            }
            if (this.currentStep === 3) {
                if (this.isEditingMode) {
                    this.currentStep = 4;
                    this.setDefaultValues();
                } else {
                    this.currentStep--;
                    if (this.selectedType['CODE'] === 'bez-dverey') {
                        this.selectedTypes.length -= 1;
                        this.currentStep--;
                    }
                    this.selectedConstruct = {};
                }
            }
            if (this.currentStep === 5) {
                this.currentStep--;
            }
        },
        chooseType(type) {
            const typeId = Number(type['ID']);

            if (
                (this.selectedTypeId > 0 && !_.isEmpty(this.findTypeById(typeId, this.currentTypes)['CONSTRUCTS']))
                //|| (this.types[typeId] && !_.isEmpty(this.types[typeId]['CONSTRUCTS']))
            ) {
                this.currentStep++;
            }

            if (type['CODE'] === 'bez-dverey') {
                const construct = Object.values({...type['CONSTRUCTS']})[0];
                this.chooseConstruct(toRaw(construct));
            }

            if (!this.selectedTypesIdentifiers.includes(typeId)) {
                this.selectedTypes.push(type);
            }
        },
        chooseConstruct(construct) {
            this.selectedConstruct = construct;

            this.constructGlasses = this.selectedConstruct['GLASS'];
            this.selectedGlassArticle = _.first(Object.keys(this.constructGlasses));
            this.constructDecoration = this.selectedConstruct['DECORATION'];
            this.selectedDecorationArticle = _.first(Object.keys(this.constructDecoration));

            this.currentStep++;

            let sizes = this.standardSizes[0];
            [this.height, this.sideSize1, this.sideSize2] = sizes ? sizes['sizes'] : [];

            this.selectedSizesIndex = (this.isFences || this.isPartitions) ? 'custom' : 0;

            this.quantity = 1;

            this.lockEnabled = this.mountingEnabled = this.deliveryEnabled = false;

            this.furnitureType = 'default';
        },
        quantityFocus($event) {
            $event.target.value = '';
        },
        quantityBlur($event) {
            this.quantity = this.fixNumber($event.target.value);

            $event.target.value = this.quantityTitle;
        },
        kDoorFocus($event) {
            $event.target.value = '';
        },
        kDoorBlur($event) {
            this.KDoor = this.fixNumber($event.target.value);

            $event.target.value = this.KDoor;
        },
        formatNumber(number) {
            return String(new Intl.NumberFormat('ru-RU').format(number));
        },
        plural(a, one, several, many) {
            if (a > 1000000) {
                return many;
            }

            if (a > 1000 && a < 1000000 && /000$/.test(a.toString())) {
                a /= 1000;
            }

            if (a % 10 === 1 && a % 100 !== 11 || /1000$/.test(a.toString())) {
                return one;
            } else if (a % 10 >= 2 && a % 10 <= 4 && (a % 100 < 10 || a % 100 >= 20)) {
                return several;
            } else {
                return many;
            }
        },
        findTypeById(typeId, subTypes = []) {
            let resultType = null,
                typesCollection = _.isEmpty(subTypes) ? this.types : subTypes;

            Object.values(typesCollection).forEach(type => {
                if (resultType === null && Number(type['ID']) === Number(typeId)) {
                    resultType = type;
                }

                if (resultType === null && !_.isEmpty(type['SUB_TYPES'])) {
                    let subResult = this.findTypeById(typeId, type['SUB_TYPES']);
                    if (subResult !== null) {
                        resultType = subResult;
                    }
                }
            });

            return resultType;
        },
        addProductToCart() {
            let data = {
                action: this.isEditingMode ? 'editProductInCart' : 'addProductToCart',
                product: this.productParameters,
            };

            if (this.isEditingMode) {
                data['cartProductId'] = this.currentCartProductId;
            }

            axios
                .post(location.pathname, data)
                .then(response => {
                    const cartProduct = response.data['cartProduct'];
                    this.cart[cartProduct['CART_PRODUCT_ID']] = cartProduct;

                    this.setDefaultValues();

                    if (this.isEditingMode) {
                        this.currentStep = 4;
                        this.sendMetric('editcartcalc');
                    } else {
                        this.sendMetric('addtocartcalc');
                        Modal.openModal('modal-calculator-add-to-cart');
                    }
                })
                .catch(response => {
                    console.error(response.data.error);
                });
        },
        editCartProduct(cartProduct) {
            this.isEditingMode = true;
            this.currentCartProductId = cartProduct['CART_PRODUCT_ID'];
            this.currentStep = 3;

            this.selectedTypes = cartProduct['TYPES'].map(typeId => this.findTypeById(typeId)).filter(type => type);

            this.selectedConstruct = this.selectedType['CONSTRUCTS'][cartProduct['CONSTRUCT']];

            this.furnitureType = cartProduct['FURNITURE_TYPE'];

            this.selectedGlassArticle = cartProduct['GLASS'];
            this.constructGlasses = this.selectedConstruct['GLASS'];

            this.selectedDecorationArticle = cartProduct['DECORATION'];
            this.constructDecoration = this.selectedConstruct['DECORATION'];

            this.selectedSizesIndex = 'custom';

            this.lockEnabled = cartProduct['ADDITIONAL']['USE_LOCK'];
            this.mountingEnabled = cartProduct['ADDITIONAL']['USE_MOUNTING'];
            this.deliveryEnabled = cartProduct['ADDITIONAL']['USE_DELIVERY'];

            this.height = cartProduct['SIZES']['HEIGHT'];
            this.sideSize1 = cartProduct['SIZES']['SIZE_1'];
            this.sideSize2 = cartProduct['SIZES']['SIZE_2'];

            this.quantity = cartProduct['QUANTITY'];
        },
        removeCartProduct(cartProduct, event) {
            axios
                .post(location.pathname, {
                    action: 'removeCartProduct',
                    cartProductId: cartProduct['CART_PRODUCT_ID'],
                })
                .then(response => {
                    delete this.cart[response.data['cartProductId']];

                    if (this.cartLength === 0) {
                        this.setDefaultValues();
                        this.currentStep = 1;
                    }

                    const item = $(event.target).closest('.calculator-cart-item');

                    item.addClass('removed');

                    setTimeout(function () {
                        return item.remove();
                    }, 400);
                })
                .catch(response => {
                    console.error(response.data.error);
                });
        },
        setDefaultValues() {
            this.selectedConstruct = {};
            this.selectedTypes = [];

            this.furnitureType = 'default';

            this.selectedGlassArticle = '';
            this.selectedDecorationArticle = '';

            this.constructGlasses = [];
            this.constructDecoration = {};

            this.selectedSizesIndex = 0;

            this.lockEnabled = this.mountingEnabled = this.deliveryEnabled = false;

            this.height = 2000;
            this.sideSize1 = 6000;
            this.sideSize2 = 6000;

            this.quantity = 1;

            this.currentStep = 1;

            this.isEditingMode = false;
        },
        fallbackCopyTextToClipboard(text) {
            const textArea = document.createElement("textarea");
            textArea.value = text;

            // Avoid scrolling to bottom
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                // noinspection JSDeprecatedSymbols
                const successful = document.execCommand('copy');
                const msg = successful ? 'successful' : 'unsuccessful';
                console.log('Fallback: Copying text command was ' + msg);
            } catch (err) {
                console.error('Fallback: Oops, unable to copy', err);
            }

            document.body.removeChild(textArea);
        },
        copyTextToClipboard(text) {
            if (!navigator.clipboard) {
                this.fallbackCopyTextToClipboard(text);
                return;
            }
            navigator.clipboard.writeText(text).then(function () {
                console.log('Async: Copying to clipboard was successful!');
            }, function (err) {
                console.error('Async: Could not copy text: ', err);
            });
        },
        copyCalculatorCart() {
            this.copyTextToClipboard(`${location.origin + location.pathname}?calculator_user_hash=${this.userKey}`);

            this.$refs.basketCopyText.textContent = 'Скопировано';
            setTimeout(() => {
                this.$refs.basketCopyText.textContent = 'Скопировать ссылку на расчет';
            }, 3000);
        },
        pdfCalculator() {
            window.open(location.pathname + '?make_calculator_pdf=yes');
        },
        sendOrder() {
            axios
                .post(location.pathname, {
                    action: 'sendOrder',
                    name: this.name,
                    email: this.email,
                    phone: this.$refs.formPhone.value,
                    summary: this.cartSummary,
                    message: this.getOrderMessage(),
                })
                .then(response => {
                    if (response.data.success) {
                        this.sendComagicEvent();

                        this.sendMetric('successfulorder');

                        Modal.openModal('modal-calculator-sent');

                        this.emitter.emit('order-send-result', {
                            orderId: response.data['orderId'],
                            cart: response.data['cart'],
                            totalSummary: response.data['totalSummary'],
                        });

                        this.cart = {};
                        this.currentStep = 1;

                        this.name = this.email = this.phone = '';

                        this.setDefaultValues();
                    }
                })
                .catch(response => {
                    console.error(response.data.error);
                });
        },
        saveHashPage() {
            this.isHashPage = false;

            // noinspection JSIgnoredPromiseFromCall
            axios.post(location.pathname, {
                action: 'saveUserKey',
                key: this.userKey,
            });
        },
        sendMetric(key) {
            this.emitter.emit('calculator-send-metric', {key});

            let sessionKey = `metric_${this.metricId}_${key}`;
            if (typeof ym === 'function' && this.metricId > 0 && sessionStorage.getItem(sessionKey) !== 'true') {
                // noinspection JSUnresolvedFunction
                ym(this.metricId, 'reachGoal', key);
                sessionStorage.setItem(sessionKey, true);
            }
        },
        sendComagicEvent() {
            return;//temporary? disabled
            // noinspection JSUnresolvedFunction,JSUnresolvedVariable
            if (typeof Comagic === 'object' && typeof Comagic.addOfflineRequest === 'function') {
                // noinspection JSUnresolvedFunction,JSUnresolvedVariable
                Comagic.addOfflineRequest({
                    name: this.name,
                    email: this.email,
                    phone: this.$refs.formPhone.value,
                    message: this.getOrderMessage()
                });
            }
        },
        getOrderMessage() {
            let message = 'Состав заказа: \n\n';

            Object.values(this.cart).forEach(item => {
                message += `Название: ${item['NAME']} \n` +
                    `Количество: ${item['QUANTITY']} шт \n` +
                    `Высота: ${item['SIZES']['HEIGHT']} \n` +
                    `Сторона 1: ${item['SIZES']['SIZE_1']} \n` +
                    `Сторона 2: ${item['SIZES']['SIZE_2']} \n`;

                if (typeof this.constructs[item['CONSTRUCT']] !== 'undefined') {
                    message += `Конструктив: ${this.constructs[item['CONSTRUCT']]['FULL_NAME_VALUE']} (${item['CONSTRUCT']}) \n`;
                } else {
                    message += `Конструктив: (${item['CONSTRUCT']}) \n`;
                }

                if (typeof this.glass[item['GLASS']] !== 'undefined') {
                    message += `Стекло: ${this.glass[item['GLASS']]['NAME']} (${item['GLASS']}) \n`;
                } else {
                    message += `Стекло: (${item['GLASS']}) \n`;
                }

                if (typeof this.decoration[item['DECORATION']] !== 'undefined') {
                    message += `Декорирование: ${this.decoration[item['DECORATION']]['NAME']} (${item['DECORATION']}) \n`;
                } else {
                    message += `Декорирование: (${item['DECORATION']}) \n`;
                }

                message += `Доставка: ${item['ADDITIONAL']['USE_DELIVERY'] ? 'да' : 'нет'} \n` +
                    `Монтаж: ${item['ADDITIONAL']['USE_MOUNTING'] ? 'да' : 'нет'} \n` +
                    `Замки: ${item['ADDITIONAL']['USE_LOCK'] ? 'да' : 'нет'} \n` +
                    `Цена: ${item['PRICE']} \n` +
                    `Сумма: ${item['SUMMARY_PRICE']} \n\n`;

                message += '\n';
            });

            message += `Сумма заказа: ${this.cartSummary}`;
            return message;
        }
    }
}

